import { render } from "./App.vue?vue&type=template&id=38f16c11"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=38f16c11&lang=postcss"
script.render = render

export default script